import { ADVANCED_SEARCH, CREATE_PAGE } from '@confluence/named-routes/entry-points/routes.ts';

const CONTEXT_PATH = '/wiki';
interface BuildFindMoreResultsUrlParams {
	labels: string[];
	spaces: string[];
}

interface BuildCreateContentUrlParams {
	hasBlueprintExperience: boolean;
	contentBlueprintId?: string;
	spaceKey?: string;
}

export const buildFindMoreResultsUrl = ({
	labels,
	spaces,
}: BuildFindMoreResultsUrlParams): string => {
	return ADVANCED_SEARCH.toUrl(
		{},
		{
			query: {
				product: 'confluence',
				labels: labels.join(','),
				...(spaces.length > 0 && { spaces: spaces.join(',') }),
			},
		},
	);
};

export const buildCreateContentUrl = ({
	hasBlueprintExperience,
	contentBlueprintId,
	spaceKey,
}: BuildCreateContentUrlParams): string | undefined => {
	if (!hasBlueprintExperience || !contentBlueprintId || !spaceKey) {
		return undefined;
	}

	return CREATE_PAGE.toUrl(
		{ spaceKey, contentType: 'pages' },
		{
			query: {
				blueprintModuleCompleteKey: contentBlueprintId,
			},
		},
	);
};

export const buildCreatorProfileUrl = (accountId: string): string =>
	`${CONTEXT_PATH}/people/${accountId}?ref=confluence`;

export function normalizeContentUrl(url: string | null | undefined): string | null {
	if (!url) {
		return null;
	}

	if (/^https?:\/\//i.test(url) || url.startsWith(CONTEXT_PATH)) {
		return url;
	}

	if (url.startsWith('/')) {
		return `${CONTEXT_PATH}${url}`;
	}

	return `${CONTEXT_PATH}/${url}`;
}
